<template>
    <div>
        <div class="page-header">
            <h2>Área de pruebas</h2>
        </div>

        <!-- Form Section -->
        <div class="form-section">
            <el-form :inline="true" :model="formData" :label-position="'top'" class="demo-form-inline">
                <el-form-item label="Teléfono">
                    <el-input v-model="formData.telefono" placeholder="Teléfono" size="mini"></el-input>
                </el-form-item>
                <el-form-item label="Tipo Teléfono">
                    <el-select v-model="formData.telefono_tipo" placeholder="Seleccione tipo" size="mini">
                        <el-option label="CPP" value="CPP"></el-option>
                        <el-option label="BASICA" value="BASICA"></el-option>
                        <el-option label="ERROR" value="ERROR"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="Teléfono Alt 1">
                    <el-input v-model="formData.telefono_alt_1" placeholder="Teléfono Alternativo"
                        size="mini"></el-input>
                </el-form-item>
                <el-form-item label="Tipo Teléfono Alt 1">
                    <el-select v-model="formData.telefono_alt_1_tipo" placeholder="Seleccione tipo" size="mini">
                        <el-option label="CPP" value="CPP"></el-option>
                        <el-option label="BASICA" value="BASICA"></el-option>
                        <el-option label="ERROR" value="ERROR"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="button-group">
                    <el-button type="primary" size="mini" :loading="loading" @click="actualizarCasos">Actualizar todos
                        Casos</el-button>
                    <el-button type="danger" size="mini" :loading="loading" @click="reiniciarCasos">Reiniciar Todos los
                        Casos</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- Table Section -->
        <div class="table-section">
            <el-table :data="casos" size="mini" fit border height="600" style="width: 100%">
                <el-table-column prop="nroint" label="Nro Int"></el-table-column>
                <el-table-column prop="paciente_nombre" label="Paciente"></el-table-column>
                <!-- <el-table-column prop="estado_rec" label="Estado"></el-table-column> -->
                <el-table-column prop="number_case" label="Número Caso"></el-table-column>
                <el-table-column label="Teléfono">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.telefono" size="mini"
                            @blur="actualizarCampo(scope.row, 'telefono')"
                            @keyup.enter.native="handleEnter($event, scope.$index, 'telefono')"
                            :ref="`telefono_${scope.$index}`">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column label="Tipo Teléfono">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.telefono_tipo" size="mini"
                            @change="actualizarCampo(scope.row, 'telefono_tipo')"
                            @keyup.enter.native="handleEnter($event, scope.$index, 'telefono_tipo')"
                            :ref="`telefono_tipo_${scope.$index}`">
                            <el-option label="CPP" value="CPP"></el-option>
                            <el-option label="BASICA" value="BASICA"></el-option>
                            <el-option label="ERROR" value="ERROR"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="Teléfono Alt 1">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.telefono_alt_1" size="mini"
                            @blur="actualizarCampo(scope.row, 'telefono_alt_1')"
                            @keyup.enter.native="handleEnter($event, scope.$index, 'telefono_alt_1')"
                            :ref="`telefono_alt_1_${scope.$index}`">
                        </el-input>
                    </template>
                </el-table-column>
                <el-table-column label="Tipo Teléfono Alt 1">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.telefono_alt_1_tipo" size="mini"
                            @change="actualizarCampo(scope.row, 'telefono_alt_1_tipo')"
                            @keyup.enter.native="handleEnter($event, scope.$index, 'telefono_alt_1_tipo')"
                            :ref="`telefono_alt_1_tipo_${scope.$index}`">
                            <el-option label="CPP" value="CPP"></el-option>
                            <el-option label="BASICA" value="BASICA"></el-option>
                            <el-option label="ERROR" value="ERROR"></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="Acciones" width="220">
                    <template slot-scope="scope">
                        <el-button size="mini" type="success" :loading="loading"
                            :disabled="!scope.row.telefono || !scope.row.telefono_tipo"
                            @click="crearCaso(scope.row)">Crear Caso</el-button>
                        <el-tooltip content="Limpiar caso" placement="top" effect="light">
                            <el-button size="mini" type="warning" icon="el-icon-toilet-paper" circle :loading="loading"
                                @click="limpiarCaso(scope.row)"></el-button>
                        </el-tooltip>
                        <el-tooltip content="Ver detalles" placement="top" effect="light">
                            <el-button size="mini" type="info" icon="el-icon-view" circle :loading="loading"
                                @click="verMas(scope.row)"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- Dialog for detailed view -->
        <el-dialog title="Detalles del Caso" center top="1vh" :visible.sync="dialogVisible" width="70%">
            <table class="details-table">
                <tbody>
                    <tr v-for="(value, key) in selectedCase" :key="key">
                        <td class="label">{{ formatLabel(key) }}</td>
                        <td class="value">{{ value }}</td>
                    </tr>
                </tbody>
            </table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size="mini">Cerrar</el-button>
            </span>
        </el-dialog>

        <!-- Dialog for response data -->
        <el-dialog title="Respuesta del Servicio" center top="1vh" :visible.sync="responseDialogVisible" width="70%">
            <table class="details-table">
                <tbody>
                    <tr v-for="(value, key) in responseData[0]" :key="key">
                        <td class="label">{{ formatLabel(key) }}</td>
                        <td class="value">{{ value }}</td>
                    </tr>
                </tbody>
            </table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="responseDialogVisible = false" size="mini">Cerrar</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { HTTP, TEST } from '@/axios'

export default {
    name: 'Pruebas',
    data() {
        return {
            casos: [],
            formData: {
                telefono: '',
                telefono_tipo: '',
                telefono_alt_1: '',
                telefono_alt_1_tipo: ''
            },
            dialogVisible: false,
            responseDialogVisible: false,
            selectedCase: null,
            responseData: [],
            loading: false
        }
    },
    created() {
        this.getCasosTest()
    },
    methods: {
        async getCasosTest() {
            this.loading = true
            try {
                const response = await HTTP.get(TEST + '/getCasosTest')
                this.casos = response.data
            } catch (error) {
                this.$alert(error.response.data.message, 'Error', {
                    confirmButtonText: 'OK',
                    type: 'error'
                })
            } finally {
                this.loading = false
            }
        },
        async actualizarCasos() {
            this.loading = true
            try {
                this.formData.id = 0
                const response = await HTTP.post(TEST + '/setDatosPrueba', this.formData)

                this.$message.success('Casos actualizados correctamente')
                if (response) {
                    this.getCasosTest()
                }
            } finally {
                this.loading = false
            }
        },
        async reiniciarCasos() {
            this.loading = true
            try {
                await this.$confirm('¿Está seguro de reiniciar todos los casos?', 'Advertencia', {
                    confirmButtonText: 'Sí',
                    cancelButtonText: 'No',
                    type: 'warning'
                })
                // Implementar lógica para reiniciar casos
                const response = await HTTP.post(TEST + '/LimpiarTabla', { id: 0 })
                this.$message.success('Casos reiniciados correctamente')
                if (response) {
                    this.getCasosTest()
                }
            } catch (error) {
                if (error !== 'cancel') {
                    this.$message.error('Error al reiniciar los casos')
                }
            } finally {
                this.loading = false
            }
        },
        async actualizarCampo(row, campo) {
            try {
                const data = {
                    id: row.id,
                    [campo]: row[campo]
                }
                await HTTP.post(TEST + '/setDatosPrueba', row)
                this.$message.success('Campo actualizado correctamente')
            } catch (error) {
                this.$message.error('Error al actualizar el campo')
                console.error(error)
            }
        },
        crearCaso(row) {
            this.loading = true
            HTTP.post(TEST + '/crearCasoWise', { id: row.id })
                .then(response => {
                    console.log(response);
                    this.responseData = Array.isArray(response.data) ? response.data : [response.data]
                    this.responseDialogVisible = true
                    this.getCasosTest()
                })
                .catch(error => {
                    this.$message.error('Error al crear el caso')
                    console.error(error)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        async limpiarCaso(row) {
            this.loading = true
            try {
                const response = await HTTP.post(TEST + '/LimpiarTabla', { id: row.id })
                this.$message.success('Casos limpiado correctamente')
                if (response) {
                    this.getCasosTest()
                }
                this.$message.success('Caso limpiado correctamente')
            } finally {
                this.loading = false
            }
        },
        verMas(row) {
            this.selectedCase = row
            this.dialogVisible = true
        },
        formatLabel(key) {
            // Convert camelCase or snake_case to Title Case with spaces
            return key
                .replace(/_/g, ' ')
                .replace(/([A-Z])/g, ' $1')
                .replace(/^./, str => str.toUpperCase())
                .trim();
        },
        handleEnter(event, rowIndex, currentField) {
            // Actualizar el campo actual
            this.actualizarCampo(this.casos[rowIndex], currentField)

            // Determinar el siguiente campo
            const fields = ['telefono', 'telefono_tipo', 'telefono_alt_1', 'telefono_alt_1_tipo']
            const currentIndex = fields.indexOf(currentField)
            const nextField = fields[currentIndex + 1]

            if (nextField) {
                // Encontrar el siguiente input/select en la misma fila
                const nextInput = this.$refs[`${nextField}_${rowIndex}`]
                if (nextInput) {
                    // Si es un select, necesitamos enfocar el input interno
                    if (nextField.includes('tipo')) {
                        nextInput.$el.querySelector('input').focus()
                    } else {
                        nextInput.focus()
                    }
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.page-header {
    padding: 13px;
    background: #fff;
    border-bottom: 1px solid #e6e6e6;

    h2 {
        margin: 0;
        color: #303133;
        font-size: 20px;
    }
}

.form-section {
    padding: 20px;
    background: #f1f1f1;
    margin-bottom: 10px;
    padding-bottom: 10px;

    :deep(.el-form-item__label) {
        padding-bottom: 2px;
        line-height: 1;
    }

    :deep(.el-form-item__content) {
        line-height: 1;
    }

    .button-group {
        margin-top: 19px;
        margin-bottom: 0;
    }
}

.table-section {
    padding: 0 20px;
    background: #fff;
}

.el-form-item {
    margin-bottom: 18px;
}

.el-button+.el-button {
    margin-left: 5px;
}

.details-table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;

    tr {
        border-bottom: 1px solid #EBEEF5;

        &:last-child {
            border-bottom: none;
        }
    }

    td {
        padding: 12px;

        &.label {
            width: 200px;
            font-weight: bold;
            color: #606266;
            background-color: #F5F7FA;
        }

        &.value {
            color: #303133;
        }
    }
}
</style>